<template>
    <div class="layout-pods">
        <header class="layout-pods-header pg-header">
            <div>
                <tab-buttons v-show="$isAllowed('edit')" class="d-none d-sm-block" ref="tabs" @changeTab="changeTab" 
                  :tabs="
                    $isAllowed('archive')
                      ? [{ name: 'My Offices', isActive: true }, { name: 'Archived', isActive: false }]
                      : [{ name: 'My Offices', isActive: true }]
                  ">
                </tab-buttons>
                <tab-buttons v-show="$isAllowed('edit')" class="d-block d-sm-none" ref="tabs" @changeTab="changeTab"
                    :tabs="[{ name: 'My Offices', isActive: true }]">
                </tab-buttons>
            </div>
            <div class="agencies-filter orders">
                <div class="" v-if="$isAllowed('filterClient')">
                    <client-list-dropdown :value="selectedClient" @on-client-selected="handleClientSelected" @on-client-removed="handleClientRemoved" :style="{ width: '300px' }"/>
                </div>
                <form id="client-search" class="search-form campaigns-client-search ml-4">
                    <input class="form-control" type="search" placeholder="Search" aria-label="Search"
                        v-model="searchText" :disabled="selectedClient === null">
                </form>
            </div>
        </header>
        <app-action-needed
            v-if="selectedClient === null"
            title="No client selected"
            description="Please select a client to get started."
        />
        <app-no-data-available
            v-if="selectedClient && agencies.length === 0"
            title="No offices found"
            :description='`No office found for ${selectedClient.title} with the given criteria.`'
        />
        <div class="pods-container">
            <section class="notifications-list">
                <template>
                    <ol v-if="agencies.length > 0">
                        <li>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-2 d-none d-md-block">
                                    </div>
                                    <div class="col-1 d-none d-md-block">
                                        <b></b>
                                    </div>
                                    <div class="col-12" :class="$route.params.client ? 'col-sm-3' : 'col-sm-7'">
                                        <b>Office</b>
                                    </div>
                                    <div class="col-2 d-none d-md-block">
                                        <b>Payment Method</b>
                                    </div>
                                    <div class="col-2 d-none d-md-block" v-if="$route.params.client">
                                        <b>Active Campaigns</b>
                                    </div>
                                    <div class="col-2 d-none d-md-block" v-if="$route.params.client">
                                        <b>Total Campaigns</b>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-for="agency in agencies" :key="agency.id">
                            <div class="container-fluid">
                                <div class="row" style="padding:10px">
                                    <div class="col-2 d-none d-md-block">
                                        <div class="logo">
                                            <img :src='getLogo(agency)'
                                                :style="[agency.backgroundColor ? { 'background': agency.backgroundColor, 'padding': '5px' } : '']" />
                                        </div>
                                    </div>
                                    <div class="col-1 vertical-align-middle align-right d-none d-md-block"
                                        @click.stop.prevent="openModal(agency)">
                                        <button class="btn btn-primary btn-sm">Edit</button>
                                    </div>
                                    <div class="col-12 vertical-align-middle"
                                        :class="$route.params.client ? 'col-sm-3' : 'col-sm-7'">
                                        <p><a href="href" @click.prevent="viewCampaigns(agency)">{{ agency.displayName
                                        }}</a></p>
                                    </div>
                                    <div class="col-2 vertical-align-middle d-none d-md-block">
                                        <p v-if="agency.propertyCampaignPaymentOption == 'credit-card'">Credit Card</p>
                                        <p v-if="agency.propertyCampaignPaymentOption == 'trading-terms'">Trading Terms</p>
                                    </div>
                                    <div class="col-2 vertical-align-middle d-none d-md-block" v-if="$route.params.client">
                                        {{ agency.campaignCountFetched ? parseInt(agency.activePropertyCampaignCount) +
                                            parseInt(agency.activeAgencyCampaignCount) : '-' }}
                                    </div>
                                    <div class="col-2 vertical-align-middle d-none d-md-block" v-if="$route.params.client">
                                        {{ agency.campaignCountFetched ? parseInt(agency.propertyCampaignCount) +
                                            parseInt(agency.agencyCampaignCount) : '-' }}
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ol>
                </template>
            </section>
        </div>
        <div class="col-12 mt-4" v-if="agencies.length > 0 && hasMorePages">
            <div class="btn-container" style="text-align: center">
            <button
                class="btn-primary btn"
                @click="currentCursor = nextCursor"
            >
                Load more
            </button>
            </div>
        </div>
        <transition name="modal">
            <agency-modal v-if="showModal" :agency-id="agencyId" @closeModal="closeModal"></agency-modal>
        </transition>
    </div>
</template>

<script>
import TabButtons from '../../helpers/TabButtons';
import AgencyModal from './AgencyModal';
import AgencyServices from '../../services/agencies';
import AgencyPerimeters from '../../configs/Perimeters/agencies';
import { refreshPageMixin } from '../../mixins/refreshPage';
import ClientListDropdown, { ClientListAllOption } from '../Clients/ClientListDropdown.vue';
import { FilterBuilder } from '../../helpers/FilterBuilder';
import AppActionNeeded from '../AppComponents/AppActionNeeded.vue';
import AppNoDataAvailable from "../AppComponents/AppNoDataAvailable.vue";

export default {
    mixins: [refreshPageMixin],
    perimeters: [AgencyPerimeters],
    components: {
        TabButtons,
        AgencyModal,
        ClientListDropdown,
        AppActionNeeded,
        AppNoDataAvailable
    },
    data() {
        return {
            currentTabName: 'My Offices',
            showModal: false,
            agencyId: false,
            agencies: [],
            searchText: "",
            agencyClients: [],
            selectedClient: null,
            filterBuilder: new FilterBuilder(),
            searchTimeout: null,
            status: "published",
            currentCursor: 0,
            nextCursor: 0,
            hasMorePages: true
        }
    },
    computed: {
        filters() {
            return this.filterBuilder.get();
        },
    },
    methods: {
        getLogo(agency) {
            let source = 'data:image/png;base64,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';

            const cdnUrl =process.env.VUE_APP_CDN_URL;

            if (agency.imageLogo) {
                const startsWithHttp = agency.imageLogo.location.startsWith('http');
                source = startsWithHttp ? agency.imageLogo.location : `${cdnUrl}${agency.imageLogo.location}`;
            };

            if (agency && agency.client && agency.client.clientDisplayConfig && agency.client.clientDisplayConfig.imageAdLogo) {
                source = `${cdnUrl}${agency.client.clientDisplayConfig.imageAdLogo.location}`;  
            }
            
            return source;
        },
        viewCampaigns(agency) {
            if (agency.status !== 'archived') {
                this.$router.push({ name: 'AgencyOrders', params: { agency: agency.slug.name, activeRoute: 'campaigns' } });
            }
        },
        closeModal() {
            this.showModal = false;
            this.agencyId = null;
            this.getAgencies();
        },
        openModal(agency) {
            if (agency && agency.status !== 'archived') {
                this.showModal = true;
                this.agencyId = agency.id;
            } else if (agency === null) {
                this.showModal = true;
            }
        },
        changeTab(tab) {
            this.currentTabName = tab.name;
            this.status = tab.name === 'Archived' ? 'archived' : 'published'

            const filters = this.filterBuilder.get();
            const hasFilter = Object.keys(filters).length;

            if (!hasFilter) return;

            this.resetCursor();
            this.getAgencies();
        },
        unArchive(agency) {
            agency.status = 'published';
            AgencyServices.updateAgency(agency).then(agency => {
                this.getAgencies();
                this.$refs.tabs.changeTab({ name: 'My Offices' });
            }).catch((errors) => {
                this.errors = errors;
            });
        },
        getAgencies() {
            AgencyServices.getAgencies(this.status, 'client,clientDisplayConfig', 'packages', this.currentCursor, this.filterBuilder.get()).then(response => {
                this.agencies = this.currentCursor === 0 ? response.data : [...this.agencies, ...response.data];
                const hasNext = response.meta.cursor.hasOwnProperty("next");
                this.hasMorePages = hasNext;
                if (hasNext) {
                    this.nextCursor = response.meta.cursor.next.cursor;
                }
            });
        },
        handleClientSelected(client) {
            // If all clients option is selected:
            if (client.id === ClientListAllOption.id) {
                this.filterBuilder.addFilter('clients', []);
            } else {
                this.filterBuilder.addFilter('clients', [client.id]);
            }
            this.selectedClient = client;
        },
        handleClientRemoved() {
            this.filterBuilder.removeFilter('clients');
            this.selectedClient = null;
            this.agencies = [];
        },
        resetCursor() {
            this.currentCursor = 0;
        },
        initData() {
            /**
             * If current user isn't allowed to filter clients, call the getAgencies()
             * method which will return their client-specific data.
             */
            if (this.$isAllowed('filterClient') === false) {
                this.selectedClient = {
                    id: this.$store.getters.getUser.clientId,
                    title: this.$store.getters.getUser.client,
                }
                this.filterBuilder.addFilter('clients', [this.$store.getters.getUser.clientId]);
                this.getAgencies();
                return;
            } 
            
            const urlObj = new URL(window.location);
            const queryParams = new URLSearchParams(urlObj.search);
            const selectedClientQueryParams = queryParams.get("selectedClient") ? JSON.parse(queryParams.get("selectedClient")) : null;

            if (null !== selectedClientQueryParams) {
                this.filterBuilder.addFilter('clients', [selectedClientQueryParams.id]);
                this.selectedClient = selectedClientQueryParams;
                this.getAgencies()
                return;
            }
        }
    },
    watch: {
        selectedClient: {
            handler(value){
                if (!value) return;
                this.resetCursor();
                this.getAgencies()
            }
        },
        searchText: {
            handler(value){
                clearTimeout(this.searchTimeout);

                if (!value) {
                    this.filterBuilder.removeFilter('searchText');
                } else {
                    this.filterBuilder.addFilter('searchText', value);
                }

                this.searchTimeout = setTimeout(() => {
                    this.resetCursor();
                    this.getAgencies()
                }, 1000);
            }
        },
        currentCursor: {
            handler(value) {
                if (value === 0) return;

                this.getAgencies();
            }
        }
    },
    mounted() {
        this.initData()
    }
}
</script>

<style lang="css">
.logo img {
    width: 50%;
    height: auto;
}

.vertical-align-middle {
    display: block !important;
    align-items: center !important;
}
</style>
